import { useState, useMemo, useCallback,  } from "react";
import { Skeleton, IconButton, Box, } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import LoadingMoreArticles from '../LoadingMoreArticles.js'
import SmallArticleList from '../ArticleComponents/SmallArticleList.js'
import {carouselPaginationEnabled} from '../utils.js'
// import './ArticleCategory.css'

export default function ArticleCategory(props = {}) {

  const {
    editable,
    ouCornerCategory,
    articles,
    loading,
    loadingMore,
    totalArticlesAvailable,
    moreAvailable,
    loadMoreArticles,
    window
  } = props

  const moreArticlesAvailable = (totalArticlesAvailable !== undefined && totalArticlesAvailable > articles?.length) || moreAvailable
  const [startIndex, setStartIndex] = useState(0)
  const [isSliding, setIsSliding]   = useState(false);
  const [showLoadingMore, setShowLoadingMore] = useState(false)

  const prevArticle = () => {
    setStartIndex(startIndex - 1)
  };

  const WINDOW = window;
  const SLIDE_MS = 450;   

  const nextArticle = async () => {
    const nextIndex = startIndex + 1;

    if (!moreArticlesAvailable && nextIndex >= articles?.length) {
      setStartIndex(0);
      return;
    }

    const needMore =
      nextIndex + (WINDOW - 1) >= articles.length &&
      moreArticlesAvailable;

    if (needMore) {
      setShowLoadingMore(true)
      await loadMoreArticles()
      setShowLoadingMore(false)
    }

    setStartIndex(startIndex + 1);
  };

  const visibleArticles = useMemo(() => {
    if (!articles?.length) return [];
    if (articles.length <= WINDOW) return articles

    const visible = [];
    for (let i = 0; i < WINDOW; i++) {
      const index = ((startIndex + i) % articles.length + articles.length) % articles.length;
      visible.push(articles[index]);
    }

    return visible;
  }, [articles, startIndex, WINDOW]);

  const [showPrev, showNext] = carouselPaginationEnabled(WINDOW, articles.length, totalArticlesAvailable, moreAvailable, startIndex)
    
  return (<>
    {loading || visibleArticles?.length > 0 ? <>
    
      {loading && <Skeleton sx={{margin: '4px !important'}} className="tertiary-article-height article-tile"></Skeleton>}
      {!loading &&
        <SmallArticleList
          editable={editable && !loading}
          ouCorner
          ouCornerCategory={ouCornerCategory}
          published={true}
          articles={visibleArticles}
          loading={loading}
          loadingMore={loadingMore}
          showPrevious={showPrev}
          showNext={showNext}
          onPrevious={prevArticle}
          onNext={nextArticle}
          compact
          tilesPerRow={window}
        />}

    </> : <span>No Articles</span>}
  </>);
}

